import { ReactNode } from 'react';
import { IControlProps, IPartialFormGroup } from '../types';
import FormControl from '../FormControl';
import { useHookFormController } from '../../hooks/useHookFormController';
import InputPassword, { IInputPasswordProps } from '../../atoms/InputPassword';

export type IInputPasswordControlProps = IInputPasswordProps &
    IControlProps & {
        formGroupProps?: IPartialFormGroup;
        label?: ReactNode;
        tooltip?: ReactNode;
        required?: boolean;
    };

const InputPasswordControl = ({
    name,
    rules,
    defaultValue,
    control,
    shouldUnregister,
    label,
    tooltip,
    required,
    formGroupProps,
    hideErrorMessage,
    ...props
}: IInputPasswordControlProps) => {
    const Controller = useHookFormController();

    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            shouldUnregister={shouldUnregister}
            defaultValue={defaultValue}
            render={({ field: { onChange, value, ...fieldProps } }) => (
                <FormControl
                    // у отключённого поля Mantine прячет кнопку просмотра — замок встаёт к краю, как у обычного поля
                    readonlyAppearance={
                        props.readOnly || props.disabled
                            ? props.withVisibilityToggle === false || props.disabled
                                ? 'field'
                                : 'password'
                            : undefined
                    }
                    name={name}
                    label={label}
                    tooltip={tooltip}
                    required={required}
                    control={control}
                    hideErrorMessage={hideErrorMessage}
                    {...formGroupProps}
                >
                    <InputPassword
                        {...fieldProps}
                        {...props}
                        value={value ?? ''}
                        onValueChange={(value) => {
                            onChange(value);
                            props.onValueChange && props.onValueChange(value);
                        }}
                    />
                </FormControl>
            )}
        />
    );
};

export default InputPasswordControl;
